import { Component, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ToasterService } from '../../../service/common/toaster.service';
import { CommonService, CrudComponent } from 'wire-frame';
import { EMPTY, Subscription } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

import { TagModule } from 'primeng/tag';
import { DropdownModule } from 'primeng/dropdown';
import { ToolbarModule } from 'primeng/toolbar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditorModule } from 'primeng/editor';
import { ButtonModule } from 'primeng/button';
import { TabViewModule } from 'primeng/tabview';
import { InputTextModule } from 'primeng/inputtext';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SidebarModule } from 'primeng/sidebar';
import { TooltipModule } from 'primeng/tooltip';

import { PharmacyService } from '../../../service/admin/pharmacy.service';
import { AppointmentService } from '../../../service/admin/appointment.service';
import { PatientRegistrationService } from '../../../service/admin/patient-registration.service';
import { PrescriptionsService } from '../../../service/admin/prescriptions.service';
import { EchoService } from '../../../services/echo.service';

import { StatusBadgePipe } from '../../../status-badge.pipe';

@Component({
  selector: 'app-pharmacy',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    TagModule,
    DropdownModule,
    ToolbarModule,
    ConfirmDialogModule,
    CrudComponent,
    EditorModule,
    ButtonModule,
    TabViewModule,
    AccordionModule,
    ScrollPanelModule,
    InputTextModule,
    FileUploadModule,
    InputTextareaModule,
    FloatLabelModule,
    SidebarModule,
    TooltipModule,
    StatusBadgePipe
  ],
  providers: [ConfirmationService, CommonService, PharmacyService, AppointmentService, PatientRegistrationService],
  templateUrl: './pharmacy.component.html',
  // templateUrl: './pharmacy.component-copy.html',
  styleUrls: ['./pharmacy.component.scss'],
  //   styles: [
  //     `
  //       .queue-item {
  //   padding: 6px 10px !important;
  //   font-size: 14px !important;
  // }

  // .compact-card .form-control-sm {
  //   padding: 3px 6px !important;
  // }

  // .table-sm th, 
  // .table-sm td {
  //   padding: 4px 6px !important;
  //   font-size: 13px !important;
  // }

  // .small {
  //   font-size: 12px !important;
  // }

  //     `
  //   ],
})
export class PharmacyComponent implements OnInit, OnDestroy {
  private readonly distanceViewStorageKey = 'pharmacy_distance_view';
  public distanceView: boolean = false;

  public role: string = '';
  activeIndex: number = 0;
  pationtIndex: number = 0;

  public PharmacyList: any[] = [];
  public editRecord: any = null;

  public Pharmacy: any = {
    id: '',
    name: '',
    medicines: '',
    visit_date: new Date().toISOString().slice(0, 10), // date in YYYY-MM-DD
    visit_time: '', // new field for pickup time
  };

  public patientIndex = 0;
  public queue: any[] = [];
  public isQueueRefreshing: boolean = false;
  public nextPatientIndex: number = -1;
  public scheduledQueue: any[] = [];
  public dateWiseQueue: any[] = [];
  public scheduledQueueSearchTerm: string = '';
  public scheduledQueueModeFilter: 'ALL' | 'OPD' | 'COURIER' | 'NRI' = 'ALL';
  public scheduledQueueUrgencyFilter: 'all' | 'overdue' | 'today' | 'tomorrow' | 'upcoming' = 'all';
  public scheduledQueueGroups: Array<{ key: string; label: string; items: any[] }> = [];
  public scheduledQueueCounts: Record<'all' | 'overdue' | 'today' | 'tomorrow' | 'upcoming', number> = {
    all: 0,
    overdue: 0,
    today: 0,
    tomorrow: 0,
    upcoming: 0
  };
  // public dateWisePrescriptions: any[] = [];
  // public selectedDate: string = new Date().toISOString().slice(0, 10);
  public selectedDate = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
  public selectedDateForQueue = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
  public selectedPatient: any = {};
  filteredRecords: any[] = [];

  clinicId: number = 0; // Default clinic ID
  doctorId: number = 0; // Default clinic ID

  scheduledLaterQueue: boolean = false;
  public selectedPatientSource: 'normal' | 'datewise' | null = null;
  private queueRefreshTimer: ReturnType<typeof setInterval> | null = null;
  private openMedicineQueueListener?: () => void;
  private hotkeySidebarEl: Element | null = null;
  private hasShownLargePayloadWarning: boolean = false;
  private selectPatientSub: Subscription | null = null;
  public isSelectingPatient: boolean = false;
  private selectingAppointmentId: number | null = null;

  public patient: any = {
    id: 0,  // number: Unique ID
    first_name: '',
    middle_name: '',
    last_name: '',
    primary_contact: '',  // string: Phone number
    secondary_contact: '',  // string: Phone number
    age: 0,
    blood_group: '',
    gender: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pincode: '',
    marital_status: '',
    is_free: false,     // number: Age in years  // boolean: true = free visit,     // string: Courier-related info
    scanned_card: null as File | null, // File upload (can be null or File)

    visit_date: new Date(),

    // Date of first visit
    first_visit: '', // Date of first visit
    patient_number: '',
    is_courier: 'OPD',
  };

  public prescription: any = {
    appointment_id: 0,
    allergies: '',
    current_medications: '',
    personal_family_history: '',
    surgical_history: '',
    blood_pressure: '',
    pulse_rate: '',
    temperature: '',
    weight: '',
    height: '',
    fasting_blood_sugar: '',
    blood_oxygen: '',
    runny_nose: '',
    cough: '',
    chief_complaints: '',
    suggested_reports: '',

    prescriptions: [
      {
        id: 1,
        title: '',
        duration: '',
        medicines: [
          {
            // id: 0,
            name: '',
            drams: '',
            ballers: ''
          }
        ]
      }
    ],

    personal_dues: 0,
    visit_fees: 0,
    received_cash: 0,
    received_online: 0,

    note: '',
    special_instructions: '',
    is_courier: 'OPD',

  }

  public closeFormEvent: boolean = false;
  public openDeletePopup: any = null;
  public activeMenu: string = 'basic';

  constructor(
    public common: CommonService,
    private toast: ToasterService,
    private confirmationService: ConfirmationService,
    private PharmacyService: PharmacyService,
    private patientRegistrationService: PatientRegistrationService,
    private appointmentService: AppointmentService,
    private prescriptionsService: PrescriptionsService,
    private cdr: ChangeDetectorRef,
    private statusBadgePipe: StatusBadgePipe,
    private echoService: EchoService
  ) {
    this.common.breadCrum = {
      title: 'Pharmacy',
      icon: 'users',
      list: ['Pharmacy'],
    };

    this.common.setCrudTableHeaders([
      { title: 'Company Name', val: 'companyName', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Contact Person', val: 'contactPerson', id: 'id', showColumn: true, filterColmn: true, order: 'asc', searchColumn: true, type: 'string', globalSearch: true },
      { title: 'Phone Number', val: 'phoneNumber', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false },
      { title: 'Email Address', val: 'emailAddress', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false },
      { title: 'Address', val: 'address', id: 'id', showColumn: true, filterColmn: false, order: 'asc', searchColumn: false, type: 'string', globalSearch: false },
    ]);

    this.common.setCrudActions([
      { title: '', icon: 'pi-pencil', classArr: 'me-2', tooltip: 'Update Pharmacy' },
      { title: '', icon: 'pi-trash', tooltip: 'Delete Pharmacy' },
    ]);
  }

  ngOnInit() {
    this.loadDistanceViewPreference();

    // Removed WebSockets (Echo), relying on 15s polling instead.

    // this.getPharmacy();
    if (this.common.getLoggedInUser()) {
      this.role = (this.common.getLoggedInUser()?.type || this.common.getLoggedInUser()?.role || '').toString().toLowerCase();
      this.loadQueue();
      this.loadScheduledLaterQueue();
      this.loadDateWisePrescriptions();
    }

    this.hotkeySidebarEl = document.querySelector('[data-hotkey="patient-search"]');
    this.openMedicineQueueListener = () => this.openscheduleLaterQueueSidebar();
    this.hotkeySidebarEl?.addEventListener('open-medicine-queue', this.openMedicineQueueListener);

    this.queueRefreshTimer = setInterval(() => {
      if (this.common.getLoggedInUser()) {
        this.role = (this.common.getLoggedInUser()?.type || this.common.getLoggedInUser()?.role || '').toString().toLowerCase();
        this.loadQueue();
        // this.loadScheduledLaterQueue();
      }
    }, 8000);
  }

  ngOnDestroy(): void {
    if (this.queueRefreshTimer) {
      clearInterval(this.queueRefreshTimer);
      this.queueRefreshTimer = null;
    }
    if (this.hotkeySidebarEl && this.openMedicineQueueListener) {
      this.hotkeySidebarEl.removeEventListener('open-medicine-queue', this.openMedicineQueueListener);
    }
    if (this.selectPatientSub) {
      this.selectPatientSub.unsubscribe();
      this.selectPatientSub = null;
    }
    this.openMedicineQueueListener = undefined;
    this.hotkeySidebarEl = null;
  }

  private loadDistanceViewPreference() {
    try {
      this.distanceView = localStorage.getItem(this.distanceViewStorageKey) === '1';
    } catch {
      this.distanceView = false;
    }
  }

  toggleDistanceView() {
    this.distanceView = !this.distanceView;
    try {
      localStorage.setItem(this.distanceViewStorageKey, this.distanceView ? '1' : '0');
    } catch {
      // no-op if storage is unavailable
    }
  }

  openPatientSearch() {
    // this.isPatientVisible = true;
    this.patientIndex = 1; // Search tab

    // Focus the autocomplete after sidebar opens
    setTimeout(() => {
      const input = document.querySelector(
        'p-autoComplete input'
      ) as HTMLInputElement;

      input?.focus();
    }, 300);
  }

  getPharmacy() {
    this.PharmacyService.getPharmacyList().subscribe((res: any) => {
      this.PharmacyList = res.data;
      console.log('Pharmacy List:', this.PharmacyList);
    });
  }

  closeForm() {
    this.clearForm();
    this.closeFormEvent = true;
    setTimeout(() => {
      this.closeFormEvent = false;
    }, 1);
  }

  clearForm() {
    this.patient = {
      id: 0,  // number: Unique ID
      first_name: '',
      middle_name: '',
      last_name: '',
      primary_contact: '',  // string: Phone number
      secondary_contact: '',  // string: Phone number
      age: 0,
      blood_group: '',
      gender: '',
      address: '',
      city: '',
      state: '',
      country: '',
      pincode: '',
      marital_status: '',
      is_free: false,     // number: Age in years  // boolean: true = free visit,     // string: Courier-related info
      scanned_card: null as File | null, // File upload (can be null or File)

      visit_date: new Date(),

      // Date of first visit
      first_visit: '', // Date of first visit
      is_courier: 'OPD',
    };

    this.prescription = {
      appointment_id: 0,
      allergies: '',
      current_medications: '',
      personal_family_history: '',
      surgical_history: '',
      blood_pressure: '',
      pulse_rate: '',
      temperature: '',
      weight: '',
      height: '',
      fasting_blood_sugar: '',
      blood_oxygen: '',
      runny_nose: '',
      cough: '',
      chief_complaints: '',
      suggested_reports: '',

      prescriptions: [
        {
          id: 1,
          title: '',
          duration: '',
          medicines: [
            {
              // id: 0,
              name: '',
              drams: '',
              ballers: ''
            }
          ]
        }
      ],

      personal_dues: 0,
      visit_fees: 0,
      received_cash: 0,
      received_online: 0,
      card_dues: 0,

      notes: '',
      special_instructions: '',
      is_courier: 'OPD',
    }

    // ✅ Reset history + reports
    this.filteredRecords = [];   // prescription history
    this.nextPatientIndex = -1;
  }

  normalizePatientMode(mode: any): 'OPD' | 'COURIER' | 'NRI' {
    if (mode === 'NRI') {
      return 'NRI';
    }

    if (
      mode === true ||
      mode === 'true' ||
      mode === 1 ||
      mode === '1' ||
      mode === 'Courier' ||
      mode === 'COURIER'
    ) {
      return 'COURIER';
    }

    return 'OPD';
  }

  getModeInitial(mode: any): 'O' | 'C' | 'N' {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'C';
    if (normalized === 'NRI') return 'N';
    return 'O';
  }

  getModeTitle(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'Courier';
    if (normalized === 'NRI') return 'NRI';
    return 'OPD';
  }

  getModeBadgeClass(mode: any): string {
    const normalized = this.normalizePatientMode(mode);
    if (normalized === 'COURIER') return 'mode-courier';
    if (normalized === 'NRI') return 'mode-nri';
    return 'mode-opd';
  }

  private sanitizeNamePart(value: any): string {
    if (value === null || value === undefined) return '';

    const part = String(value).trim();
    if (!part || part.toLowerCase() === 'null' || part.toLowerCase() === 'undefined') {
      return '';
    }

    return part;
  }

  private buildPatientDisplayName(patient: any): string {
    const name = [
      this.sanitizeNamePart(patient?.first_name),
      this.sanitizeNamePart(patient?.middle_name),
      this.sanitizeNamePart(patient?.last_name)
    ].filter(Boolean).join(' ');

    if (name) return name;

    return this.sanitizeNamePart(patient?.full_name) || this.sanitizeNamePart(patient?.name);
  }

  refreshQueue() {
    if (this.isQueueRefreshing) return;
    this.loadQueue(true);
  }

  loadQueue(manualRefresh: boolean = false) {
    if (manualRefresh) {
      this.isQueueRefreshing = true;
    }

    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select the clinic and doctor',
      });
      // return; // stop execution
    }

    // const date = this.selectedDate || new Date().toISOString().slice(0, 10);
    const date = this.selectedDateForQueue || new Date(Date.now() + 19800000).toISOString().slice(0, 10);

    const role = this.role || (this.common.getLoggedInUser()?.type || this.common.getLoggedInUser()?.role || '').toString().toLowerCase();

    const payload = {
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      slot: 60
    };

    const queueObservable = (role === 'assistant_doctor' || role === 'reception')
      ? this.appointmentService.getOnlyMedicineQueue(payload)
      : this.appointmentService.getQueue(payload);

    queueObservable.subscribe({
      next: (res: any) => {
        if (res.success) {
          const appointments = res.data.slots.flatMap((slot: any) =>
            slot.appointments.map((appt: any) => ({
              appointment_id: appt.id,
              patient_id: appt.patient_id,
              clinic_id: appt.clinic_id,
              doctor_id: appt.doctor_id,
              time: appt.start_time,
              raw_time: appt.start_time,
              status: appt.status,
              is_courier: this.normalizePatientMode(appt.is_courier),
              appointment_type: appt.appointment_type
            }))
          );

          // Collect all patient IDs
          const patientIds = appointments.map((a: any) => a.patient_id);

          if (!patientIds.length) {
            this.queue = [];
            this.updateNextPatientIndex();
            this.checkIfActivePatientRecalled(role);

            if (manualRefresh) {
              this.isQueueRefreshing = false;
            }
            return;
          }

          // Fetch all patient data in one request
          this.patientRegistrationService.getPatientsBatch(patientIds)
            .subscribe({
              next: (patientRes: any) => {
                if (patientRes.success) {
                  const patientsMap = new Map();
                  patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

                  // Map appointments to patients
                  this.queue = appointments.map((appt: any) => {
                    const patient = patientsMap.get(appt.patient_id);
                    const displayName = this.buildPatientDisplayName(patient);
                    return {
                      name: displayName,
                      full_name: displayName,
                      time: this.formatTime(appt.time),
                      raw_time: appt.raw_time,
                      status: appt.status,
                      primary_contact: patient.primary_contact,
                      secondary_contact: patient.secondary_contact,
                      is_free: patient.is_free,
                      age: patient.age,
                      gender: patient.gender,
                      appointment_type: appt.appointment_type,
                      appointment_id: appt.appointment_id,
                      clinic_id: appt.clinic_id,
                      doctor_id: appt.doctor_id,
                      is_courier: this.normalizePatientMode(patient?.is_courier ?? appt.is_courier)
                    };
                  });

                  // Sort by time once
                  this.queue.sort((a, b) => a.time.localeCompare(b.time));
                  this.updateNextPatientIndex();

                  this.checkIfActivePatientRecalled(role);
                  // console.log('Loaded queue:', this.queue);
                }
                if (manualRefresh) {
                  this.isQueueRefreshing = false;
                }
              },
              error: () => {
                if (manualRefresh) {
                  this.isQueueRefreshing = false;
                }
              }
            });
        }
        if (manualRefresh && !res?.success) {
          this.isQueueRefreshing = false;
        }
      },
      error: () => {
        if (manualRefresh) {
          this.isQueueRefreshing = false;
        }
      }
    });
  }

  private checkIfActivePatientRecalled(role: string) {
    // if (this.prescription?.appointment_id) {
    //   console.log('[Pharmacy Polling Check] Active prescription ID:', this.prescription.appointment_id, 'Role:', role, 'Patient Status:', this.patient?.status);

    //   if (['medicine', 'reception', 'medicine_scheduled'].includes(this.patient?.status)) {
    //     const currentItem = this.queue.find((item: any) => Number(item.appointment_id) === Number(this.prescription.appointment_id));
    //     console.log('[Pharmacy Polling Check] Current item in queue:', currentItem);

    //     const isRecalled = (role === 'pharmacy' && !currentItem) || (currentItem && currentItem.status === 'doctor');
    //     console.log('[Pharmacy Polling Check] isRecalled evaluated to:', isRecalled, 'closeFormEvent:', this.closeFormEvent, 'isSelectingPatient:', this.isSelectingPatient);

    //     if (isRecalled && !this.closeFormEvent && !this.isSelectingPatient) {
    //       console.log('[Pharmacy Polling Check] Triggering alert and closing form!');
    //       this.toast.add({
    //         severity: 'error',
    //         summary: 'Prescription Recalled',
    //         detail: 'Dr. Sancheti has recalled this prescription. Halting process.',
    //         life: 6000
    //       });
    //       this.closeForm();
    //     }
    //   }
    // }

    if (this.prescription?.appointment_id) {
      // console.log('[Pharmacy Polling Check] Active prescription ID:', this.prescription.appointment_id);

      const currentItem = this.queue.find(
        (item: any) =>
          Number(item.appointment_id) === Number(this.prescription.appointment_id)
      );

      // console.log('[Pharmacy Polling Check] Current item in queue:', currentItem);

      const isRecalled = !currentItem;

      if (isRecalled && !this.closeFormEvent && !this.isSelectingPatient) {
        // console.log('[Pharmacy Polling Check] Triggering alert and closing form!');

        this.toast.add({
          severity: 'error',
          summary: 'Prescription Recalled',
          detail: 'Doctor has recalled this prescription. Halting process.',
          life: 6000
        });

        this.closeForm();
      }
    }
  }

  private readonly nextQueuePriority: string[] = [
    'medicine',
    'doctor',
    'assistant_doctor_done',
    'assistant_doctor',
    'scheduled'
  ];

  private updateNextPatientIndex() {
    this.nextPatientIndex = -1;
    if (!Array.isArray(this.queue) || this.queue.length === 0) return;

    for (const status of this.nextQueuePriority) {
      const idx = this.queue.findIndex((item: any) => item?.status === status);
      if (idx !== -1) {
        this.nextPatientIndex = idx;
        this.scrollNextQueueItemIntoView();
        return;
      }
    }

    this.scrollNextQueueItemIntoView();
  }

  isNextPatient(index: number): boolean {
    return index === this.nextPatientIndex;
  }

  private scrollNextQueueItemIntoView() {
    setTimeout(() => {
      const target = document.querySelector('.queue-next-target') as HTMLElement | null;
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }, 0);
  }

  loadScheduledLaterQueue() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select the clinic and doctor',
      });
    }

    this.appointmentService.getScheduledLaterMedicineQueue({
      clinic_id: clinicId,
      doctor_id: doctorId
    }).subscribe((res: any) => {
      if (!res.success) return;

      const items = res.data;

      // Map only the fields we need
      this.scheduledQueue = items.map((item: any) => {
        const appt = item.appointment;
        const patient = item.appointment.patient;

        return {
          prescription_id: item.prescription_id,
          patient_name: this.buildPatientDisplayName(patient),
          patient_number: patient?.patient_number || '',
          primary_contact: patient?.primary_contact || '',
          appointment_id: appt.id,
          patient_id: appt.patient_id,
          clinic_id: appt.clinic_id,
          doctor_id: appt.doctor_id,
          is_courier: this.normalizePatientMode(patient?.is_courier ?? appt?.is_courier),

          collection_date: item.collection_date,
          days_remaining: item.days_remaining,

          appointment_type: appt.appointment_type,
          appointment_date: appt.appointment_date,
          status: appt.status,
          start_time: appt.start_time,
          end_time: appt.end_time
        };
      });

      // Sort by closest upcoming date
      this.scheduledQueue.sort((a, b) =>
        new Date(a.collection_date).getTime() - new Date(b.collection_date).getTime()
      );

      this.recomputeScheduledQueueView();
    });
  }

  private getUrgencyBucketKey(item: any): 'overdue' | 'today' | 'tomorrow' | 'upcoming' {
    const daysRemaining = Number(item?.days_remaining);

    if (Number.isFinite(daysRemaining)) {
      if (daysRemaining < 0) return 'overdue';
      if (daysRemaining === 0) return 'today';
      if (daysRemaining === 1) return 'tomorrow';
      return 'upcoming';
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(item?.collection_date);
    target.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((target.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

    if (diffDays < 0) return 'overdue';
    if (diffDays === 0) return 'today';
    if (diffDays === 1) return 'tomorrow';
    return 'upcoming';
  }

  private applyScheduledQueueFilters(list: any[]): any[] {
    const query = (this.scheduledQueueSearchTerm || '').trim().toLowerCase();
    const modeFilter = this.scheduledQueueModeFilter;

    return (list || []).filter((item: any) => {
      const mode = this.normalizePatientMode(item?.is_courier);
      if (modeFilter !== 'ALL' && mode !== modeFilter) {
        return false;
      }

      if (!query) {
        return true;
      }

      const haystack = [
        item?.patient_name,
        item?.patient_number,
        item?.primary_contact,
        item?.collection_date
      ]
        .map((v: any) => String(v || '').toLowerCase())
        .join(' ');

      return haystack.includes(query);
    });
  }

  onScheduledQueueFilterChange() {
    this.recomputeScheduledQueueView();
  }

  setScheduledQueueUrgencyFilter(filter: 'all' | 'overdue' | 'today' | 'tomorrow' | 'upcoming') {
    if (this.scheduledQueueUrgencyFilter === filter) return;
    this.scheduledQueueUrgencyFilter = filter;
    this.recomputeScheduledQueueView();
  }

  getScheduledQueueGroups(): Array<{ key: string; label: string; items: any[] }> {
    const filtered = this.applyScheduledQueueFilters(this.scheduledQueue);
    const grouped = {
      overdue: [] as any[],
      today: [] as any[],
      tomorrow: [] as any[],
      upcoming: [] as any[],
    };

    for (const item of filtered) {
      grouped[this.getUrgencyBucketKey(item)].push(item);
    }

    const groups = [
      { key: 'overdue', label: 'Overdue', items: grouped.overdue },
      { key: 'today', label: 'Today', items: grouped.today },
      { key: 'tomorrow', label: 'Tomorrow', items: grouped.tomorrow },
      { key: 'upcoming', label: 'Upcoming', items: grouped.upcoming }
    ];

    if (this.scheduledQueueUrgencyFilter === 'all') {
      return groups.filter(group => group.items.length > 0);
    }

    return groups.filter(
      group => group.key === this.scheduledQueueUrgencyFilter && group.items.length > 0
    );
  }

  getScheduledQueueUrgencyCount(filter: 'all' | 'overdue' | 'today' | 'tomorrow' | 'upcoming'): number {
    const filtered = this.applyScheduledQueueFilters(this.scheduledQueue);

    if (filter === 'all') {
      return filtered.length;
    }

    return filtered.filter((item: any) => this.getUrgencyBucketKey(item) === filter).length;
  }

  private recomputeScheduledQueueView() {
    const filtered = this.applyScheduledQueueFilters(this.scheduledQueue);
    const grouped = {
      overdue: [] as any[],
      today: [] as any[],
      tomorrow: [] as any[],
      upcoming: [] as any[]
    };

    for (const item of filtered) {
      grouped[this.getUrgencyBucketKey(item)].push(item);
    }

    this.scheduledQueueCounts = {
      all: filtered.length,
      overdue: grouped.overdue.length,
      today: grouped.today.length,
      tomorrow: grouped.tomorrow.length,
      upcoming: grouped.upcoming.length
    };

    const allGroups = [
      { key: 'overdue', label: 'Overdue', items: grouped.overdue },
      { key: 'today', label: 'Today', items: grouped.today },
      { key: 'tomorrow', label: 'Tomorrow', items: grouped.tomorrow },
      { key: 'upcoming', label: 'Upcoming', items: grouped.upcoming }
    ];

    if (this.scheduledQueueUrgencyFilter === 'all') {
      this.scheduledQueueGroups = allGroups.filter(group => group.items.length > 0);
      return;
    }

    this.scheduledQueueGroups = allGroups.filter(
      group => group.key === this.scheduledQueueUrgencyFilter && group.items.length > 0
    );
  }

  getScheduledQueueBadgeClass(item: any): string {
    const key = this.getUrgencyBucketKey(item);
    if (key === 'overdue') return 'urgency-overdue';
    if (key === 'today') return 'urgency-today';
    if (key === 'tomorrow') return 'urgency-tomorrow';
    return 'urgency-upcoming';
  }

  trackByScheduledGroup(_: number, group: { key: string }) {
    return group.key;
  }

  trackByScheduledItem(_: number, item: any) {
    return item?.appointment_id ?? item?.prescription_id ?? item?.patient_id ?? _;
  }

  onDateChange() {
    if (!this.selectedDate) return;
    const today = new Date(Date.now() + 19800000).toISOString().slice(0, 10);
    // if (this.selectedDate === today) return;
    this.loadDateWisePrescriptions();
  }

  loadDateWisePrescriptions() {
    const clinicId = sessionStorage.getItem('clinic_id') || '1';
    const doctorId = sessionStorage.getItem('doctor_id') || '1';

    // ✅ Check if clinic or doctor not selected
    if (!clinicId || !doctorId) {
      this.toast.add({
        severity: 'warn',
        summary: 'Missing Selection',
        detail: 'Select the clinic and doctor',
      });
      // return; // stop execution
    }

    const date = this.selectedDate;
    // const date = this.selectedDate || new Date(Date.now() + 19800000).toISOString().slice(0, 10);

    this.appointmentService.getDateWisePrescription({
      clinic_id: clinicId,
      doctor_id: doctorId,
      date: date,
      // date: "2025-09-12",
      slot: 60
    }).subscribe((res: any) => {
      if (res.success) {
        const appointments = res.data.slots.flatMap((slot: any) =>
          slot.appointments.map((appt: any) => ({
            appointment_id: appt.id,
            patient_id: appt.patient_id,
            clinic_id: appt.clinic_id,
            doctor_id: appt.doctor_id,
            time: appt.start_time,
            status: appt.status,
            is_courier: this.normalizePatientMode(appt.is_courier)
          }))
        );

        // Collect all patient IDs
        const patientIds = appointments.map((a: any) => a.patient_id);

        // Fetch all patient data in one request
        this.patientRegistrationService.getPatientsBatch(patientIds)
          .subscribe((patientRes: any) => {
            if (patientRes.success) {
              const patientsMap = new Map();
              patientRes.data.forEach((p: any) => patientsMap.set(p.id, p));

              // Map appointments to patients
              this.dateWiseQueue = appointments.map((appt: any) => {
                const patient = patientsMap.get(appt.patient_id);
                const displayName = this.buildPatientDisplayName(patient);
                return {
                  name: displayName,
                  full_name: displayName,
                  time: this.formatTime(appt.time),
                  status: appt.status,
                  primary_contact: patient.primary_contact,
                  secondary_contact: patient.secondary_contact,
                  is_free: patient.is_free,
                  blood_group: patient.blood_group,
                  age: patient.age,
                  appointment_id: appt.appointment_id,
                  clinic_id: appt.clinic_id,
                  doctor_id: appt.doctor_id,
                  is_courier: this.normalizePatientMode(patient?.is_courier ?? appt.is_courier)
                };
              });

              // Sort by time once
              this.dateWiseQueue.sort((a, b) => a.time.localeCompare(b.time));
              // console.log('Loaded queue:', this.queue);
              this.cdr.detectChanges();
            }
          });
      }
    });
  }

  filterByDate() {
    throw new Error('Method not implemented.');
  }

  getMedicineCodes(tags: any[]): string {
    if (!tags || tags.length === 0) return '';
    return tags.map(tag => tag.code).join(', ');
  }

  getCodeParts(code: any): { hasHighlight: boolean; prefix: string; suffix: string } {
    const raw = String(code ?? '').trim();
    if (!raw) return { hasHighlight: false, prefix: '', suffix: '' };

    const upper = raw.toUpperCase();
    const markers = ['MT', 'BC', 'LM', 'Q'];
    const marker = markers.find((m) => upper.startsWith(m));

    if (!marker) {
      return { hasHighlight: false, prefix: raw, suffix: '' };
    }

    return {
      hasHighlight: true,
      prefix: marker,
      suffix: raw.slice(marker.length)
    };
  }

  getMedicineCodeParts(tags: any[]): { hasHighlight: boolean; prefix: string; suffix: string }[] {
    if (!Array.isArray(tags) || !tags.length) return [];
    return tags
      .map((tag) => this.getCodeParts(tag?.code))
      .filter((parts) => `${parts.prefix}${parts.suffix}`.trim().length > 0);
  }

  private safeParse(value: any) {
    try {
      return typeof value === 'string' ? JSON.parse(value) : value || [];
    } catch {
      return [];
    }
  }

  private getLatestPrescription(prescriptions: any): any {
    const list = Array.isArray(prescriptions) ? prescriptions : [];
    if (!list.length) return {};

    return [...list].sort((a: any, b: any) => {
      const aTime = a?.created_at ? new Date(a.created_at).getTime() : 0;
      const bTime = b?.created_at ? new Date(b.created_at).getTime() : 0;
      if (aTime !== bTime) return bTime - aTime;
      return (Number(b?.id) || 0) - (Number(a?.id) || 0);
    })[0] || {};
  }

  private createEmptyMedicineRow(): any {
    return {
      tags: [],
      name: '',
      drams: '',
      ballers: ''
    };
  }

  private normalizePrescriptionRows(rows: any): any[] {
    const MAX_RX_ROWS = 20;
    const MAX_MEDICINES_PER_RX = 40;
    const MAX_ROWS_JSON_LENGTH = 250000;

    if (typeof rows === 'string' && rows.length > MAX_ROWS_JSON_LENGTH) {
      if (!this.hasShownLargePayloadWarning) {
        this.hasShownLargePayloadWarning = true;
        this.toast.add({
          severity: 'warn',
          summary: 'Large Prescription',
          detail: 'Prescription payload is too large; showing a safe minimal view.'
        });
      }
      return [
        {
          id: 1,
          title: '',
          duration: '',
          medicines: [this.createEmptyMedicineRow()]
        }
      ];
    }

    const parsedRows = typeof rows === 'string' ? this.safeParse(rows) : rows;
    const sourceRaw = Array.isArray(parsedRows)
      ? parsedRows
      : (parsedRows && typeof parsedRows === 'object' ? Object.values(parsedRows) : []);
    const source = Array.isArray(sourceRaw) ? sourceRaw : [];

    const wasTrimmed = source.length > MAX_RX_ROWS;
    const trimmedRows = source.slice(0, MAX_RX_ROWS);

    if (!trimmedRows.length) {
      return [
        {
          id: 1,
          title: '',
          duration: '',
          medicines: [this.createEmptyMedicineRow()]
        }
      ];
    }

    const normalized = trimmedRows.map((rx: any, rxIndex: number) => {
      const meds = Array.isArray(rx?.medicines) ? rx.medicines : [];
      const medsTrimmed = meds.slice(0, MAX_MEDICINES_PER_RX);
      // const medicines = medsTrimmed.length
      //   ? medsTrimmed.map((m: any) => ({
      //       ...this.createEmptyMedicineRow(),
      //       ...m,
      //       tags: Array.isArray(m?.tags)
      //         ? m.tags
      //         : (typeof m?.tags === 'string' ? this.safeParse(m.tags) : [])
      //     }))
      //   : [this.createEmptyMedicineRow()];

      const medicines = medsTrimmed.length
        ? medsTrimmed.map((m: any) => {
          const tags = Array.isArray(m?.tags)
            ? m.tags
            : (typeof m?.tags === 'string' ? this.safeParse(m.tags) : []);

          return {
            ...this.createEmptyMedicineRow(),
            ...m,
            tags,
            codeParts: this.getMedicineCodeParts(tags) // 🔥 PRECOMPUTED ONCE
          };
        })
        : [{
          ...this.createEmptyMedicineRow(),
          codeParts: []
        }];

      return {
        id: rx?.id ?? rxIndex + 1,
        title: rx?.title ?? '',
        duration: rx?.duration ?? '',
        medicines
      };
    });

    if ((wasTrimmed || trimmedRows.some((rx: any) => Array.isArray(rx?.medicines) && rx.medicines.length > MAX_MEDICINES_PER_RX)) && !this.hasShownLargePayloadWarning) {
      this.hasShownLargePayloadWarning = true;
      this.toast.add({
        severity: 'warn',
        summary: 'Large Prescription',
        detail: 'Loaded prescription was very large; showing a safe subset to keep the page responsive.'
      });
    }

    return normalized;
  }

  selectFromNormalQueue(item: any) {
    this.selectPatient(item, 'normal');
  }

  selectFromDateWiseQueue(item: any) {
    this.selectPatient(item, 'datewise');
  }

  isReadOnly(): boolean {
    return this.selectedPatientSource === 'datewise';
  }

  selectPatient(item: any, source: 'normal' | 'datewise') {
    const appointmentId = Number(item?.appointment_id ?? item?.id ?? 0);
    if (!appointmentId) {
      this.toast.add({
        severity: 'error',
        summary: 'Queue Data Error',
        detail: 'Appointment id is missing for selected queue item.'
      });
      return;
    }

    if (this.isSelectingPatient && this.selectingAppointmentId === appointmentId) {
      return;
    }

    this.selectedPatient = item;
    this.selectedPatientSource = source;
    this.scheduledLaterQueue = false;
    this.hasShownLargePayloadWarning = false;

    if (this.selectPatientSub) {
      this.selectPatientSub.unsubscribe();
      this.selectPatientSub = null;
    }

    this.isSelectingPatient = true;
    this.selectingAppointmentId = appointmentId;


    // console.log('Selected patient:', this.selectedPatient);
    // 1. Change appointment status
    // this.appointmentService.changeStatus(item.appointment_id, 'doctor').subscribe({
    //   next: (res: any) => {
    //     if (res.success) {
    //       this.loadQueue(); // Refresh the queue to reflect status change
    //     }
    //   },
    //   error: (err) => {
    //     console.error('Error changing status:', err);
    //   }
    // });

    // 2. Load patient cards

    // 3. Hide patient selector (queue popup)
    // this.patientSelectedFromSearch = false;
    // this.isPatientVisible = false;

    // console.log('CALLING API', appointmentId);
    // 4. Fetch full appointment details (patient + prescriptions)
    this.selectPatientSub = this.appointmentService.getAppointmentDetails(appointmentId).pipe(
      finalize(() => {
        this.isSelectingPatient = false;
        this.selectingAppointmentId = null;
      })
    ).subscribe((res: any) => {
      // console.log('API RESPONSE RECEIVED');
      // console.log('Full appointment details:', res);

      if (res.success) {
        const appt = res.data;
        if (!appt?.patient) {
          this.toast.add({
            severity: 'error',
            summary: 'Load Failed',
            detail: 'Patient details are missing for this appointment.'
          });
          return;
        }
        const patient = appt.patient;
        const prescription = this.getLatestPrescription(appt?.prescriptions);
        // console.log('Prescription data:', prescription);

        // Patient form
        this.patient = {
          patient_id: patient.id,
          full_name: this.buildPatientDisplayName(patient),
          first_name: patient.first_name || '',
          middle_name: patient.middle_name || '',
          last_name: patient.last_name || '',
          primary_contact: patient.primary_contact || '',
          secondary_contact: patient.secondary_contact || '',
          age: patient.age || '',
          gender: patient.gender || '',
          blood_group: patient.blood_group || '',
          patient_number: patient.patient_number || '',
          address: patient.address || '',
          city: patient.city || '',
          state: patient.state || '',
          country: patient.country || '',
          pincode: patient.pincode || '',
          status: appt.status || 'Checkup',
          is_free: patient.is_free || false,
          is_courier: this.normalizePatientMode(patient.is_courier),
          first_visit: this.formatFirstVisit(patient.first_visit),
          appointment_date: appt.appointment_date,
          appointment_time: appt.start_time
        };

        // Clinic/doctor ids
        this.clinicId = appt.clinic_id || 0;
        this.doctorId = appt.doctor_id || 0;

        // console.log('MAPPING PRESCRIPTION', prescription?.prescriptions);
        // Active prescription form
        this.prescription = {
          id: prescription.id,
          appointment_id: appt.id,
          allergies: prescription.allergies || '',
          current_medications: prescription.current_medications || '',
          personal_family_history: prescription.personal_family_history || '',
          surgical_history: prescription.surgical_history || '',
          blood_pressure: prescription.blood_pressure || '',
          pulse_rate: prescription.pulse_rate || '',
          temperature: prescription.temperature || '',
          weight: prescription.weight || '',
          height: prescription.height || '',
          fasting_blood_sugar: prescription.fasting_blood_sugar || '',
          blood_oxygen: prescription.blood_oxygen || '',
          runny_nose: prescription.runny_nose || '',
          cough: prescription.cough || '',

          chief_complaints: prescription.chief_complaints || '',
          suggested_reports: prescription.suggested_reports || '',

          prescriptions: this.normalizePrescriptionRows(prescription.prescriptions),
          // prescriptions: prescription.prescriptions || [],
          // prescriptions: [],

          personal_dues: prescription.personal_dues || 0,
          visit_fees: prescription.visit_fees || 0,
          received_cash: prescription.received_cash || 0,
          received_online: prescription.received_online || 0,

          notes: prescription.notes || '',
          is_courier: this.normalizePatientMode(prescription.is_courier ?? patient.is_courier),
          special_instructions: prescription.special_instructions || '',
        };
        // console.log('normalizePrescriptionRows executed');
      } else {
        this.toast.add({
          severity: 'error',
          summary: 'Load Failed',
          detail: res?.message || 'Unable to fetch appointment details for selected patient.'
        });
      }
    }, () => {
      this.toast.add({
        severity: 'error',
        summary: 'Load Failed',
        detail: 'Unable to fetch appointment details for selected patient.'
      });
    });
  }

  // selectPatient(item: any, source: 'normal' | 'datewise') {
  //   const appointmentId = Number(item?.appointment_id ?? item?.id ?? 0);

  //   if (!appointmentId) {
  //     this.toast.add({
  //       severity: 'error',
  //       summary: 'Queue Data Error',
  //       detail: 'Appointment id is missing.'
  //     });
  //     return;
  //   }

  //   // Prevent double-click / race condition
  //   if (this.isSelectingPatient && this.selectingAppointmentId === appointmentId) {
  //     return;
  //   }

  //   // Reset & prepare state
  //   this.selectedPatient = item;
  //   this.selectedPatientSource = source;
  //   this.scheduledLaterQueue = false;
  //   this.hasShownLargePayloadWarning = false;

  //   this.selectPatientSub?.unsubscribe();

  //   this.isSelectingPatient = true;
  //   this.selectingAppointmentId = appointmentId;

  //   this.selectPatientSub = this.appointmentService
  //     .getAppointmentDetails(appointmentId)
  //     .pipe(
  //       finalize(() => {
  //         this.isSelectingPatient = false;
  //         this.selectingAppointmentId = null;
  //       })
  //     )
  //     .subscribe({
  //       next: (res: any) => {
  //         if (!res?.success || !res?.data?.patient) {
  //           this.toast.add({
  //             severity: 'error',
  //             summary: 'Load Failed',
  //             detail: 'Patient details are missing.'
  //           });
  //           return;
  //         }

  //         const appt = res.data;
  //         const patient = appt.patient;
  //         const prescription = this.getLatestPrescription(appt.prescriptions);

  //         // Map patient
  //         this.patient = {
  //           patient_id: patient.id,
  //           full_name: this.buildPatientDisplayName(patient),
  //           first_name: patient.first_name || '',
  //           middle_name: patient.middle_name || '',
  //           last_name: patient.last_name || '',
  //           patient_number: patient.patient_number || '',
  //           status: appt.status || 'Checkup',
  //           is_free: !!patient.is_free,
  //           is_courier: this.normalizePatientMode(patient.is_courier),
  //           first_visit: this.formatFirstVisit(patient.first_visit),
  //           appointment_date: appt.appointment_date,
  //           appointment_time: appt.start_time
  //         };

  //         this.clinicId = appt.clinic_id || 0;
  //         this.doctorId = appt.doctor_id || 0;

  //         // Map prescription
  //         this.prescription = {
  //           id: prescription.id,
  //           appointment_id: appt.id,
  //           prescriptions: this.normalizePrescriptionRows(
  //             prescription.prescriptions
  //           ),
  //           notes: prescription.notes || '',
  //           special_instructions: prescription.special_instructions || '',
  //           is_courier: this.normalizePatientMode(
  //             prescription.is_courier ?? patient.is_courier
  //           )
  //         };
  //       },
  //       error: () => {
  //         this.toast.add({
  //           severity: 'error',
  //           summary: 'Load Failed',
  //           detail: 'Unable to fetch appointment details.'
  //         });
  //       }
  //     });
  // }

  private formatFirstVisit(value: any): string {
    if (!value) return '';
    const date = new Date(value);
    if (isNaN(date.getTime())) return '';
    return date.toLocaleString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' });
  }

  // selectPatient(item: any, source: 'normal' | 'datewise') {
  //   // console.log('Selected patient:', item);
  //   const appointmentId = Number(item?.appointment_id ?? item?.id ?? 0);
  //   if (!appointmentId) {
  //     this.toast.add({
  //       severity: 'error',
  //       summary: 'Queue Data Error',
  //       detail: 'Appointment id is missing for selected queue item.'
  //     });
  //     return;
  //   }

  //   this.selectedPatient = item;
  //   this.selectedPatientSource = source;
  //   this.scheduledLaterQueue = false;
  //   this.hasShownLargePayloadWarning = false;

  //   if (this.selectPatientSub) {
  //     this.selectPatientSub.unsubscribe();
  //     this.selectPatientSub = null;
  //   }

  //   this.isSelectingPatient = true;
  //   // console.log('Selected patient:', this.selectedPatient);
  //   // 1. Change appointment status
  //   // this.appointmentService.changeStatus(item.appointment_id, 'doctor').subscribe({
  //   //   next: (res: any) => {
  //   //     if (res.success) {
  //   //       this.loadQueue(); // Refresh the queue to reflect status change
  //   //     }
  //   //   },
  //   //   error: (err) => {
  //   //     console.error('Error changing status:', err);
  //   //   }
  //   // });

  //   // 2. Load patient cards

  //   // 3. Hide patient selector (queue popup)
  //   // this.patientSelectedFromSearch = false;
  //   // this.isPatientVisible = false;

  //   // 4. Fetch full appointment details (patient + prescriptions)
  //   this.selectPatientSub = this.appointmentService.getAppointmentDetails(appointmentId).pipe(
  //     finalize(() => {
  //       this.isSelectingPatient = false;
  //     })
  //   ).subscribe((res: any) => {
  //     // console.log('Full appointment details:', res);

  //     if (res.success) {
  //       const appt = res.data;
  //       if (!appt?.patient) {
  //         this.toast.add({
  //           severity: 'error',
  //           summary: 'Load Failed',
  //           detail: 'Patient details are missing for this appointment.'
  //         });
  //         return;
  //       }
  //       const patient = appt.patient;
  //       const prescription = this.getLatestPrescription(appt?.prescriptions);
  //       // console.log('Prescription data:', prescription);

  //       // Patient form
  //       this.patient = {
  //         patient_id: patient.id,
  //         full_name: this.buildPatientDisplayName(patient),
  //         first_name: patient.first_name || '',
  //         middle_name: patient.middle_name || '',
  //         last_name: patient.last_name || '',
  //         primary_contact: patient.primary_contact || '',
  //         secondary_contact: patient.secondary_contact || '',
  //         age: patient.age || '',
  //         gender: patient.gender || '',
  //         blood_group: patient.blood_group || '',
  //         patient_number: patient.patient_number || '',
  //         address: patient.address || '',
  //         city: patient.city || '',
  //         state: patient.state || '',
  //         country: patient.country || '',
  //         pincode: patient.pincode || '',
  //         status: appt.status || 'Checkup',
  //         is_free: patient.is_free || false,
  //         is_courier: this.normalizePatientMode(patient.is_courier),
  //         first_visit: new Date(patient.first_visit).toLocaleString('en-GB', { day: '2-digit', month: 'long', year: 'numeric'}),
  //         appointment_date: appt.appointment_date,
  //         appointment_time: appt.start_time
  //       };

  //       // Clinic/doctor ids
  //       this.clinicId = appt.clinic_id || 0;
  //       this.doctorId = appt.doctor_id || 0;

  //       // Active prescription form
  //       this.prescription = {
  //         id: prescription.id,
  //         appointment_id: appt.id,
  //         allergies: prescription.allergies || '',
  //         current_medications: prescription.current_medications || '',
  //         personal_family_history: prescription.personal_family_history || '',
  //         surgical_history: prescription.surgical_history || '',
  //         blood_pressure: prescription.blood_pressure || '',
  //         pulse_rate: prescription.pulse_rate || '',
  //         temperature: prescription.temperature || '',
  //         weight: prescription.weight || '',
  //         height: prescription.height || '',
  //         fasting_blood_sugar: prescription.fasting_blood_sugar || '',
  //         blood_oxygen: prescription.blood_oxygen || '',
  //         runny_nose: prescription.runny_nose || '',
  //         cough: prescription.cough || '',

  //         chief_complaints: prescription.chief_complaints || '',
  //         suggested_reports: prescription.suggested_reports || '',

  //         prescriptions: this.normalizePrescriptionRows(prescription.prescriptions),

  //         personal_dues: prescription.personal_dues || 0,
  //         visit_fees: prescription.visit_fees || 0,
  //         received_cash: prescription.received_cash || 0,
  //         received_online: prescription.received_online || 0,

  //         // card_dues: prescription.card_dues || 0,
  //         notes: prescription.notes || '',
  //         is_courier: this.normalizePatientMode(prescription.is_courier ?? patient.is_courier),
  //         special_instructions: prescription.special_instructions || '',
  //       };
  //     } else {
  //       this.toast.add({
  //         severity: 'error',
  //         summary: 'Load Failed',
  //         detail: res?.message || 'Unable to fetch appointment details for selected patient.'
  //       });
  //     }
  //   }, () => {
  //     this.toast.add({
  //       severity: 'error',
  //       summary: 'Load Failed',
  //       detail: 'Unable to fetch appointment details for selected patient.'
  //     });
  //   });
  // }

  // changeStatus(item: any) {
  //     this.appointmentService.changeStatus(item.appointment_id, 'reception').pipe(
  //       switchMap((res: any) => {
  //         if (res.success) {
  //           const payload = {
  //             id: item.id,
  //             appointment_id: item.appointment_id,
  //             received_cash: item.received_cash,
  //             received_online: item.received_online,
  //             personal_dues: item.personal_dues
  //           };
  //           return this.prescriptionsService.updatePrescriptions(payload);
  //         } 
  //         return EMPTY; // stops the chain if not successful
  //       })
  //     ).subscribe({
  //       next: () => {
  //         // this.visible = false;
  //         this.loadQueue(); // Refresh only after prescriptions update
  //         this.toast.add({
  //           severity: 'success',
  //           summary: 'Success',
  //           detail: 'Medicine dispensed successfully.'
  //         });
  //         this.clearForm();
  //       },
  //       error: (err) => {
  //         console.error('Error changing status or updating prescriptions:', err);
  //         this.toast.add({
  //           severity: 'error',
  //           summary: 'Error',
  //           detail: 'Something went wrong. Please try again.'
  //         });
  //       }
  //     });
  //   }

  changeStatus(item: any) {

    const hasFollowUp = item.follow_up_date && item.follow_up_date.trim() !== '';

    // Build dynamic status payload
    const statusPayload: any = { status: 'reception' };

    if (hasFollowUp) {
      statusPayload.prescription_id = this.prescription.id;
      statusPayload.follow_up_date = item.follow_up_date;
    }

    this.appointmentService.changeStatus(item.appointment_id, statusPayload).pipe(
      switchMap((res: any) => {
        if (!res.success) return EMPTY;

        // Always update prescription billing
        const payload = {
          id: item.id,
          appointment_id: item.appointment_id,
          received_cash: item.received_cash,
          received_online: item.received_online,
          personal_dues: item.personal_dues,
          main_action: 'complete',
          collect_payment: false
        };

        return this.prescriptionsService.updatePrescriptions(payload);
      })
    ).subscribe({
      next: (res: any) => {
        if (!res?.success) {
          this.toast.add({
            severity: 'error',
            summary: 'Error',
            detail: res?.message || 'Unable to update prescription details.'
          });
          return;
        }

        this.loadQueue();
        this.loadScheduledLaterQueue();
        this.toast.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Medicine dispensed successfully.'
        });
        this.clearForm();
      },
      error: (err) => {
        console.error('Error changing status or updating prescriptions:', err);
        this.toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Something went wrong. Please try again.'
        });
      }
    });
  }

  checkChangeStatusButton() {
    console.log('button clicked');
  }

  // Code to check if the follow_up_date is being sent
  // changeStatus(item: any) {

  //   const hasFollowUp =
  //     item.follow_up_date &&
  //     item.follow_up_date.toString().trim() !== '';

  //   if (hasFollowUp) {
  //     alert('WORKING: Follow-up date detected.\n\nValue: ' + item.follow_up_date);
  //     return; // STOP EXECUTION
  //   }

  //   alert('WORKING: No follow-up date entered.');
  //   return; // STOP EXECUTION
  // }



  calculatePersonalDues(records: any[], current: any): number {
    let lastDue = 0;

    if (records && records.length > 0) {
      // Find the most recent prescription with dues > 0
      const last = records.find((r: any) => r.personal_dues && r.personal_dues >= 0);
      if (last) {
        lastDue = Number(last.personal_dues);
      }
    }

    const visitFees = Number(current.visit_fees) || 0;
    const receivedCash = Number(current.received_cash) || 0;
    const receivedOnline = Number(current.received_online) || 0;

    return (lastDue - (receivedCash + receivedOnline));
    // return (visitFees - (receivedCash + receivedOnline)) + lastDue;
  }

  getColorClass(status: string): string {
    switch (status) {
      case 'scheduled':
        return 'bg-light-blue';
      case 'assistant_doctor':
        return 'bg-light-purple';
      case 'doctor':
        return 'bg-light-coral';
      case 'medicine':
        return 'bg-light-teal';
      case 'completed':
        return 'bg-light-green';
      case 'cancelled':
        return 'bg-light-red';
      default:
        return 'bg-light-gray'; // fallback for unknown statuses
    }
  }


  // ------------------ Pharmacy CRUD Operations ------------------ //
  selectedPatients: any[] = [];
  loadedPatients: any[] = [];

  togglePatientSelection(patient: any) {
    const index = this.selectedPatients.findIndex(p => p.id === patient.id);
    if (index > -1) {
      this.selectedPatients.splice(index, 1);
    } else {
      this.selectedPatients.push(patient);
    }
  }

  isPatientSelected(patient: any): boolean {
    return this.selectedPatients.some(p => p.id === patient.id);
  }

  loadSelectedPatients() {
    this.selectedPatients.forEach(patient => {
      if (!this.loadedPatients.some(p => p.patient.id === patient.id)) {
        this.loadedPatients.push({
          patient: patient,
          prescription: patient.prescription,
          dispensed: false
        });
      }
    });
    this.selectedPatients = [];
  }

  dispenseMedicine(patientData: any) {
    // Your dispense logic here
    patientData.dispensed = true;
    this.changeStatus(patientData.prescription);
  }

  dispenseMedicineForAll() {
    this.loadedPatients.forEach(pd => {
      if (!pd.dispensed) {
        this.dispenseMedicine(pd);
      }
    });
  }

  removePatient(index: number) {
    this.loadedPatients.splice(index, 1);
  }

  clearAllPatients() {
    this.loadedPatients = [];
  }

  // FOrmat time
  formatTime(time: any): string {
    if (!time && time !== 0) return '';

    try {
      // If already HH:MM or HH:MM:SS
      if (typeof time === 'string' && /^\d{1,2}:\d{2}(:\d{2})?$/.test(time)) {
        return time.slice(0, 5).padStart(4, '0');
      }

      // If numeric timestamp
      if (typeof time === 'number') {
        const d = new Date(time);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Try parsing ISO or full datetime string
      const parsed = new Date(time);
      if (!isNaN(parsed.getTime())) {
        const hh = String(parsed.getHours()).padStart(2, '0');
        const mm = String(parsed.getMinutes()).padStart(2, '0');
        return `${hh}:${mm}`;
      }

      // Fallback to original
      return String(time).slice(0, 5);
    } catch {
      return String(time);
    }
  }

  openscheduleLaterQueueSidebar() {
    this.loadScheduledLaterQueue();
    this.scheduledLaterQueue = true;
  }

  getAppointmentClass(type: string) {
    const normalized = String(type || '').trim().toLowerCase().replace(/\s+/g, '_');
    switch (normalized) {
      case 'new':
        return 'apt-new';
      case 'follow_up':
        return 'apt-followup';
      case 'case':
        return 'apt-case';
      default:
        return 'apt-default';
    }
  }

  getAppointmentTypeLabel(type: any): string {
    const normalized = String(type || '').trim().toLowerCase().replace(/\s+/g, '_');
    if (normalized === 'new') return 'New';
    if (normalized === 'follow_up') return 'Follow Up';
    if (normalized === 'case') return 'Case';
    return 'Other';
  }

  get nowServingIndex(): number {
    return this.queue.findIndex((item: any) => item.status === 'medicine');
  }

  get nowServingPatient(): any {
    const idx = this.nowServingIndex;
    if (idx !== -1) {
      return { ...this.queue[idx], index: idx };
    }
    return null;
  }

  getModernStatusColorClass(item: any): string {
    const s = String(item?.status || '').toLowerCase();
    if (s === 'scheduled' || s === 'pending') return 'border-blue';
    if (s === 'assistant_doctor') return 'border-purple';
    if (s === 'assistant_doctor_done') return 'border-teal';
    if (s === 'doctor') return 'border-green';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'border-orange';
    if (s === 'reception' || s === 'receptionist') return 'border-cyan';
    if (s === 'completed') return 'border-gray';
    return 'border-gray';
  }

  getWaitTimeColorClass(label: string): string {
    if (!label) return 'text-muted';
    if (label.includes('In ') || label.includes('Just now')) return 'text-muted';
    const matchMins = label.match(/Waiting (\d+)m/);
    const matchHours = label.match(/Waiting (\d+)h/);
    if (matchHours) return 'text-danger fw-bolder';
    if (matchMins) {
      const mins = parseInt(matchMins[1], 10);
      if (mins < 15) return 'text-muted';
      if (mins < 30) return 'text-warning fw-semibold';
      return 'text-danger fw-semibold';
    }
    return 'text-muted';
  }

  getWaitTimeLabel(rawTime: string): string {
    if (!rawTime) return '';
    const now = new Date();
    const timeParts = rawTime.split(':');
    if (timeParts.length < 2) return '';
    const aptTime = new Date();
    aptTime.setHours(parseInt(timeParts[0], 10), parseInt(timeParts[1], 10), 0, 0);

    const diffMs = now.getTime() - aptTime.getTime();
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 0) return `In ${Math.abs(diffMins)}m`;
    if (diffMins === 0) return 'Just now';
    if (diffMins < 60) return `Waiting ${diffMins}m`;
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    return `Waiting ${hours}h ${mins}m`;
  }

  getQueueLifecycleLabel(item: any): string {
    const s = String(item?.status || '').toLowerCase();
    if (s === 'scheduled' || s === 'pending') return 'Scheduled';
    if (s === 'assistant_doctor') return 'Asst. Dr. Consulting';
    if (s === 'assistant_doctor_done') return 'Assistant Doctor Done';
    if (s === 'doctor') return 'In Consultation';
    if (s === 'medicine' || s === 'medicine_scheduled') return 'Pharmacy';
    if (s === 'reception' || s === 'receptionist') return 'Reception';
    if (s === 'completed') return 'Completed';
    return 'Waiting';
  }
}
